<template>
  <div class="pagamento-successo">
    <div class="success-card">
      <div class="success-icon">✓</div>
      <h1>{{ isTablePayment ? ($t('pagamento_completato') || 'Pagamento Completato') : $t('pagamento_successo_titolo') }}</h1>
      <p class="success-message">
        {{ isTablePayment ? ($t('tavolo_chiuso_msg') || 'Il tuo tavolo è stato chiuso correttamente.') : $t('ordine_asporto_ricevuto') }}
      </p>
      
      <div class="order-details" v-if="ordine">
        <h3>{{ $t('riepilogo_ordine') }}</h3>
        <div class="detail-row">
          <span>{{ $t('numero_ordine') }}:</span>
          <strong>{{ ordineId }}</strong>
        </div>
        <div class="detail-row">
          <span>{{ $t('nome') }}:</span>
          <strong>{{ ordine.nome }}</strong>
        </div>
        <div class="detail-row">
          <span>{{ $t('email') }}:</span>
          <strong>{{ ordine.email }}</strong>
        </div>
        <div class="detail-row">
          <span>{{ $t('telefono') }}:</span>
          <strong>{{ ordine.telefono }}</strong>
        </div>
        <div class="detail-row">
          <span>{{ $t('stato') }}:</span>
          <span class="status-badge">{{ statoLabel }}</span>
        </div>
        <div class="items-list">
          <div class="item" v-for="(item, idx) in ordine.ordinazione" :key="idx">
            {{ item.quantita }}x {{ item.piatto }} - {{ (item.prezzo * item.quantita).toFixed(2) }}€
          </div>
        </div>
        <div class="total-row">
          <span>{{ $t('totale_pagato') }}:</span>
          <strong>{{ (ordine.totale / 100).toFixed(2) }}€</strong>
        </div>
      </div>

      <p class="info-text">
        {{ isTablePayment ? ($t('tavolo_chiuso_info') || 'Grazie per essere stati con noi. Torna a trovarci presto!') : $t('ritiro_info') }}
      </p>

      <button class="btn-home" @click="goHome">{{ $t('torna_home') }}</button>
    </div>
  </div>
</template>

<script>
import { store } from '../store/store.js'

export default {
  name: 'PagamentoSuccesso',
  data() {
    return {
      store,
      ordineId: null,
      ordine: null,
      pollInterval: null
    }
  },
  computed: {
    statoLabel() {
      const stati = {
        'pendente': this.$t('in_attesa'),
        'pagato': this.$t('pagato_badge'),
        'in_preparazione': this.$t('in_preparazione'),
        'pronto': this.$t('pronto_ritiro'),
        'consegnato': this.$t('consegnato')
      }
      return stati[this.ordine?.stato] || this.ordine?.stato
    },
    isTablePayment() {
      return !!this.$route.query.tavolo;
    }
  },
  methods: {
    goHome() {
      this.$router.push({ name: 'Benvenuto' })
    },
    async fetchOrder() {
      if (!this.ordineId) return
      try {
        const response = await this.axios.get(
          this.store.path + 'getOrdineAsporto/' + this.ordineId
        )
        if (response.data.messaggio) {
          const nuovoOrdine = response.data.messaggio
          this.ordine = nuovoOrdine
          
          // Stop polling if order is delivered
          if (nuovoOrdine.stato === 'consegnato') {
            this.stopPolling()
          }
        }
      } catch (error) {
        console.error('Error fetching order:', error)
      }
    },
    stopPolling() {
      if (this.pollInterval) {
        clearInterval(this.pollInterval)
        this.pollInterval = null
      }
    },
    async confirmTablePayment(idT, idO, sessionId) {
      try {
        await this.axios.post(this.store.path + 'confermaPagamentoTavoloPubblico', {
          idT,
          idO,
          sessionId
        });
        console.log('✅ Table payment confirmed');
      } catch (error) {
        console.error('Error confirming table payment:', error);
      }
    }
  },
  mounted() {
    this.ordineId = this.$route.query.ordine
    const idT = this.$route.query.tavolo
    const sessionId = this.$route.query.session_id
    
    if (this.ordineId && idT) {
      // It's a table payment
      console.log(`💳 Table payment detected: Table ${idT}, Order ${this.ordineId}, Session ${sessionId}`);
      this.confirmTablePayment(idT, this.ordineId, sessionId);
    } else if (this.ordineId) {
      // It's a takeaway payment
      this.fetchOrder()
      // Poll every 5 seconds
      this.pollInterval = setInterval(this.fetchOrder, 5000)
    }
  },
  beforeUnmount() {
    this.stopPolling()
  }
}
</script>

<style scoped>
.pagamento-successo {
  min-height: 100vh;
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
}

.success-card {
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  padding: 40px;
  max-width: 500px;
  width: 100%;
  text-align: center;
  color: white;
}

.success-icon {
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #00ff88, #00d9ff);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 3rem;
  margin: 0 auto 20px;
  color: #1a1a2e;
}

h1 {
  color: #00ff88;
  margin-bottom: 10px;
}

.success-message {
  color: #aaa;
  font-size: 1.1rem;
  margin-bottom: 30px;
}

.order-details {
  background: rgba(0, 0, 0, 0.3);
  border-radius: 12px;
  padding: 20px;
  text-align: left;
  margin-bottom: 20px;
}

.order-details h3 {
  color: #00d9ff;
  margin-bottom: 15px;
  text-align: center;
}

.detail-row {
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.status-badge {
  background: #00ff88;
  color: #1a1a2e;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 0.85rem;
  font-weight: bold;
}

.items-list {
  margin: 15px 0;
  padding: 10px 0;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.item {
  padding: 5px 0;
  color: #ccc;
}

.total-row {
  display: flex;
  justify-content: space-between;
  padding-top: 10px;
  font-size: 1.2rem;
}

.total-row strong {
  color: #00ff88;
}

.info-text {
  color: #888;
  font-size: 0.95rem;
  margin-bottom: 25px;
}

.btn-home {
  background: linear-gradient(90deg, #00d9ff, #00ff88);
  border: none;
  padding: 14px 40px;
  border-radius: 8px;
  color: #1a1a2e;
  font-size: 1.1rem;
  font-weight: bold;
  cursor: pointer;
  transition: transform 0.2s;
}

.btn-home:hover {
  transform: translateY(-2px);
}
</style>
